/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_SelectionInputs */

const en_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Sovereign Selection`)
};

const es_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Selección Sovereign`)
};

const fr_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Sélection Sovereign`)
};

const de_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Sovereign Auswahl`)
};

const ja_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Sovereign セレクション`)
};

const zh_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Sovereign 精选`)
};

const ar_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ مختارات Sovereign`)
};

const id_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Pilihan Sovereign`)
};

const it_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Selezione Sovereign`)
};

const ru_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Sovereign Selection`)
};

const pt_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Seleção Sovereign`)
};

const ko_sovereign_selection = /** @type {(inputs: Sovereign_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✦ Sovereign 셀렉션`)
};

/**
* | output |
* | --- |
* | "✦ Sovereign Selection" |
*
* @param {Sovereign_SelectionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_selection = /** @type {((inputs?: Sovereign_SelectionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_SelectionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_selection(inputs)
	if (locale === "es") return es_sovereign_selection(inputs)
	if (locale === "fr") return fr_sovereign_selection(inputs)
	if (locale === "de") return de_sovereign_selection(inputs)
	if (locale === "ja") return ja_sovereign_selection(inputs)
	if (locale === "zh") return zh_sovereign_selection(inputs)
	if (locale === "ar") return ar_sovereign_selection(inputs)
	if (locale === "id") return id_sovereign_selection(inputs)
	if (locale === "it") return it_sovereign_selection(inputs)
	if (locale === "ru") return ru_sovereign_selection(inputs)
	if (locale === "pt") return pt_sovereign_selection(inputs)
	return ko_sovereign_selection(inputs)
});